import { motion } from 'framer-motion';
import { Clock, FileText, Users } from 'lucide-react';

interface MetadataPanelProps {
  duration: string;
  wordCount: number;
  speakerCount: number;
}

export function MetadataPanel({ duration, wordCount, speakerCount }: MetadataPanelProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
      className="w-full max-w-4xl mx-auto py-4 sm:py-6 px-2 sm:px-0"
    >
      <div className="flex items-center justify-around sm:justify-center gap-2 sm:gap-8 p-4 sm:p-6 bg-[#F0F0F0] border border-gray-200 rounded-lg">
        <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3">
          <Clock className="w-4 h-4 sm:w-5 sm:h-5 text-[#0066FF]" strokeWidth={2} />
          <div className="text-center sm:text-left">
            <div 
              className="text-[10px] sm:text-xs uppercase tracking-wider text-[#666666] font-medium"
              style={{ fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.1em' }}
            >
              Duration
            </div>
            <div 
              className="text-sm sm:text-lg font-bold tabular-nums"
              style={{ fontFamily: 'JetBrains Mono, monospace' }}
            >
              {duration}
            </div>
          </div>
        </div>

        <div className="h-8 sm:h-12 w-px bg-gray-300" />

        <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3">
          <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-[#0066FF]" strokeWidth={2} />
          <div className="text-center sm:text-left">
            <div 
              className="text-[10px] sm:text-xs uppercase tracking-wider text-[#666666] font-medium"
              style={{ fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.1em' }}
            >
              Words
            </div>
            <div 
              className="text-sm sm:text-lg font-bold tabular-nums"
              style={{ fontFamily: 'JetBrains Mono, monospace' }}
            >
              {wordCount.toLocaleString()}
            </div>
          </div>
        </div>

        <div className="h-8 sm:h-12 w-px bg-gray-300" />

        <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3">
          <Users className="w-4 h-4 sm:w-5 sm:h-5 text-[#0066FF]" strokeWidth={2} />
          <div className="text-center sm:text-left">
            <div 
              className="text-[10px] sm:text-xs uppercase tracking-wider text-[#666666] font-medium"
              style={{ fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.1em' }}
            >
              Speakers
            </div>
            <div 
              className="text-sm sm:text-lg font-bold tabular-nums"
              style={{ fontFamily: 'JetBrains Mono, monospace' }}
            >
              {speakerCount}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
